import React from 'react';
import { useTranslation } from 'react-i18next';
import { getStringOrEmpty } from '@/utils/helper';
import { FormGroupProps } from './types';
import ReadOnlyField from '@/components/common/ReadOnlyField/ReadOnlyField';

type Props = FormGroupProps & {
  handleMarketingInfo: (field: string, value: string) => void;
};

export default function ProjectOverviewFormGroup({
  album,
  readonly,
  disabled,
  handleMarketingInfo,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {!readonly ? (
        <div className="form-group">
          <label htmlFor="projectOverview" className="col-sm-3 form-label">
            {' '}
            {t(`product.editProduct.projectOverview`)}
          </label>
          <div className="col-sm-6">
            <textarea
              className="form-control"
              value={getStringOrEmpty(
                album.albumMetaData?.marketing?.projectOverview
              )}
              onChange={(e) => {
                handleMarketingInfo('projectOverview', e.target.value);
              }}
              disabled={disabled}
              maxLength={500}
              rows={4}
            ></textarea>
          </div>
        </div>
      ) : (
        <ReadOnlyField
          id={'projectOverview'}
          labelTitle={t('product.editProduct.projectOverview')}
          value={album.albumMetaData?.marketing?.projectOverview}
        ></ReadOnlyField>
      )}
    </>
  );
}
